export function Logo({ variant = "dark", className, textClass }) {
  // variant: "dark" => dark navy text (for light bg) | "light" => white text (for dark bg)
  const isLight = variant === "light";
  return (
    <div className={`flex items-center gap-2.5 ${className || ""}`} data-testid="ridestamp-logo">
      <img
        src="/brand/icon-blue-bg.png"
        alt="RideStamp"
        className="h-9 w-9 rounded-xl shadow-lg shadow-blue-900/20"
      />
      <span className={`font-display text-xl font-extrabold tracking-tight ${textClass || ""}`}>
        <span className={isLight ? "text-white" : "text-[#0B2D5B]"}>Ride</span>
        <span className="text-[#2563EB]">Stamp</span>
      </span>
    </div>
  );
}
